// extracted by mini-css-extract-plugin
export default {"container":"FixedLogoWithName_container__cnCDo","label":"FixedLogoWithName_label__pO2+t"};